module.exports = __webpack_public_path__ + "static/media/image7.65398d69.png";